export default {
    getUserInformation(state) {
        return state.userInformation;
    }
}
